import { IEntity } from 'types/common';

export const getSelectInputChoices = (items: Array<IEntity>) =>
  items ? items.map(item => ({ label: item.name, value: String(item.id) })) : [];
